@if (params.isEditing()) {
  @let context = params.editContext();

  <ng-select
    [(ngModel)]="context[params.node.rowIndex].selectedCameras"
    [items]="params.availableCameras(params.data)"
    [disabled]="params.availableCameras(params.data).length === 0 || params.isSaving()"
    bindValue="transactionId"
    bindLabel="name"
    appendTo="body"
    class="w-full"
    placeholder="Cameras..."
    [multiple]="true"
  ></ng-select>
} @else {
  {{ params.value?.length ?? 0 }}
}
